/**
 * URL mirrored (via `history.replaceState`, never a router navigation) for the
 * biomarkers explorer filter: the panel wins, else a lone add-on, else the bare
 * list. Matches the `/biomarkers/{package}` deep-link routes.
 */
export function biomarkerFilterPath(
  prefix: string,
  panel: string | null,
  addons: Iterable<string>
): string {
  const list = [...addons]
  if (panel) return `${prefix}/${panel}`
  return list.length === 1 ? `${prefix}/${list[0]}` : prefix
}
